<!--
     <ActionDownload
       size='small'
       :unit="QUnit"
     />
-->

<template>
  <ResponsiveMenuDialog ref="activator">
    <template v-slot:activator="{ toggle }">
      <slot :name="'activator'" :toggle="toggle">
        <v-icon
          :small="size == 'small'"
          :large="size == 'large'"
          :color="color"
          @click.stop="toggle()"
          :disabled="!show_action"
        >
          {{ activator_icon }}
        </v-icon>
    </slot>
    </template>

    <template v-slot:content>
      <v-list dense>
        <v-list-group
          v-if=" unit.current_state_document && (unit.current_state_document.download_options || []).length > 0"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-title>{{ $vuetify.lang.translator('actions.generic_download_evidence_options.draft') }}</v-list-item-title>
          </template>
          <v-progress-circular
            v-if="loading"
            indeterminate
            :color="color"
            :size="size == 'small' ? 20 : 30"
          />
          <v-icon
            v-else
            slot="prependIcon"
            small
            color="primary"
          >
            mdi-file-cog-outline
          </v-icon>
          <v-list-item
            v-for="option in unit.current_state_document.download_options"
            :key="option.value + '_' + option.name"
            @click="handle_evidence(option)"
          >
            <v-list-item-icon>
              <v-progress-circular
                v-if="loading"
                indeterminate
                :color="color"
                :size="size == 'small' ? 20 : 30"
              />
              <v-icon
                v-else
                small
                :color="icon_color(option)"
                class="fieldfile-icon"
              >
                {{ type_icon(option) }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ option.name }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-if="unit.current_public_version && (unit.current_public_version.download_options || []).length > 0"
          no-action          
        >
          <template v-slot:activator>
            <v-list-item-title>{{ $vuetify.lang.translator('actions.generic_download_evidence_options.current_version') }}</v-list-item-title>
          </template>
          <v-icon
            slot="prependIcon"
            small
            color="primary"
          >
            mdi-file-check-outline
          </v-icon>

          <v-list-item
            v-for="option in unit.current_public_version.download_options"
            :key="option.value + '_' + option.name"
            @click="handle_evidence(option)"
          >
            <v-list-item-icon>
              <v-progress-circular
                v-if="loading"
                indeterminate
                :color="color"
                :size="size == 'small' ? 20 : 30"
              />
              <v-icon
                v-else
                small
                :color="icon_color(option)"
                class="fieldfile-icon"
              >
                {{ type_icon(option) }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ option.name }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </template>
  </ResponsiveMenuDialog>
</template>

<style>
  .fieldfile-icon:after{
    height: unset !important;
  }
</style>

<script>
import AlertNotification from '@/components/AlertNotification'
import FileIcons from '@/utils/fileicons'
import ResponsiveMenuDialog from '@/components/ResponsiveMenuDialog'

export default {
  name: "GenericDownloadEvidenceOptions",

  components: {
    AlertNotification,
    ResponsiveMenuDialog,
  },

  props: {
    size: {
      type:String,
      default: 'small'
    },
    unit: {
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    activator_icon:{
      type: String,
      required: false,
      default: 'mdi-download'
    }
  },

  data(){
    return{
      files: FileIcons,
      isOpen: false,
    }
  }, 
  
  computed: {

    show_action() {
      return (this.unit.current_public_version && (this.unit.current_public_version.download_options || []).length > 0
        ||
        this.unit.current_state_document && (this.unit.current_state_document.download_options || []).length > 0) || this.unit.business_process =="DOCISODEFAULT";
    },

    current_version_ops() {
      return this.unit.current_public_version ? this.unit.current_public_version.download_options : "No option current v";
    },

    current_state_ops() {
      return this.unit.current_state_document ? this.unit.current_state_document.download_options : "No option state W";
    }


  },
  methods: {
    async handle_evidence(option) {
      this.$emit('option_click', option);
    },

    type_icon(opt) {
      const mimetype = opt.mimetype
      return mimetype ? this.files[mimetype].icon : 'mdi-download';
    },
    icon_color(opt) {
      const mimetype = opt.mimetype;
      return mimetype ? this.files[mimetype].color : '';
    }
  },
};
</script>
